exports = module.exports = require("./../../../../../graylog2-server/graylog2-web-interface/node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".simulation-changes{padding-top:15px}.simulation-changes dl{margin-bottom:10px;margin-top:5px}.simulation-changes dd,.simulation-changes dt{padding-left:20px}.original-message-changes{margin-top:10px}.added-fields dl{background-color:#dff0d8;color:#3c763d}.removed-fields dl{background-color:#f2dede;color:#a94442}.mutated-fields dl{background-color:#d9edf7;color:#31708f}.field-value{font-family:monospace}.mutated-fields .removed-field{text-decoration:line-through}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/jobs/graylog-project-cli-release/workspace/.repos/graylog2-server/graylog2-web-interface/~/css-loader!./src/web/simulator/SimulationChanges.css
// module id = 461
// module chunks = 0